import { apiClient } from '../lib/api-client';
import type {
  PagedResultDto,
  FacilityAdminDto,
  FacilityAdminQueryDto,
  SetFacilityStatusDto,
} from '../types/admin-api';

export const facilityService = {
  getAll: async (query: FacilityAdminQueryDto = {}) => {
    const response = await apiClient.get<PagedResultDto<FacilityAdminDto>>(
      '/facilities',
      { params: query }
    );
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<FacilityAdminDto>(`/facilities/${id}`);
    return response.data;
  },

  setStatus: async (id: string, data: SetFacilityStatusDto) => {
    const response = await apiClient.put(`/facilities/${id}/status`, data);
    return response.data;
  },
};
